import { axios } from '../libs/axios';

export function submitUserInfo (data) {
    return axios.file('/index.php/home/mail/enrol', data);
}

// export function addMessage (data) {
//     return axios.post('/website/leaveMessage/add', data);
// }

export function getCountryList (params) {
    return axios.get('/system/dict/getList', params);
}

//询盘留言接口
export function addMessage (data) {
    return axios.post('/app/test/save', data);
}

//登录
export function loginYuri (data) {
    return axios.post('/app/test/loginYuri', data);
}
//注册
export function registerYuri (data) {
    return axios.post('app/test/register', data);
}